import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { CloudUpload } from "@material-ui/icons";
import axios from "axios";
import Cookies from "universal-cookie";
import { FileUploader } from "react-drag-drop-files";
const cookies = new Cookies();

export default class UploadSpecial extends Component {
  constructor(props) {
    super();
    this.state = {
      showAddModal: false,
      showCheckModal: false,
      showSuccessModal: false,
      hasError: false,
      hasWarning: false,
      disableAdd: false,
      checkData: [],
      err_no: 0,
      rec_no: 0,
    };
    this.handleshowAddModal = this.handleshowAddModal.bind(this);
  }

  handleshowAddModal = (e) => {
    this.setState({
      showAddModal: !this.state.showAddModal,
      disableAdd: false,
      hasError: false,
      hasWarning: false,
      actual_file: null,
      file_name: null,
    });
  };

  handleshowCheckModal = (e) => {
    this.setState({
      showCheckModal: !this.state.showCheckModal,
      disableAdd: false,
      hasError: false,
      hasWarning: false,
    });
  };

  handleCheck = (e) => {
    e.preventDefault();
    // this.setState({ disableAdd: true });
    let formData = new FormData();
    formData.append("uploadFile", this.state.actual_file);
    formData.append("file_name", this.state.file_name);
    formData.append("description", this.state.description);
    formData.append("record_year", this.state.record_year);
    formData.append("company_id", cookies.get("transCompany"));
    formData.append("updated_by", cookies.get("email"));
    formData.append("created_by", cookies.get("email"));

    axios.post("api/special_import_check", formData).then((res) => {
      this.setState({
        disableAdd: false,
        showAddModal: false,
        showCheckModal: true,
        checkData: res.data.rowData,
        rec_no: res.data.rows,
        err_no: res.data.errs.length,
      });
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableAdd: true });
    let formData = new FormData();
    formData.append("uploadFile", this.state.actual_file);
    formData.append("file_name", this.state.file_name);
    formData.append("description", this.state.description);
    formData.append("company_id", cookies.get("transCompany"));
    formData.append("updated_by", cookies.get("email"));
    formData.append("created_by", cookies.get("email"));
    axios
      .post("api/special_import", formData)
      .then((res) => {
        this.props.parentCallback(true);

        if (res.data.errors) {
          this.setState({
            disableAdd: true,
            hasError: true,
            showAddModal: false,
          });

          const element = document.createElement("a");
          const file = new Blob(res.data.errors, {
            type: "text/plain",
          });
          element.href = URL.createObjectURL(file);
          element.download = this.state.file_name + "_errors.txt";
          document.body.appendChild(element);
          alert("Failed to upload file see downloaded .txt for reference");
          element.click();
        } else {
          this.setState({
            disableAdd: false,
            hasError: false,
            showAddModal: false,
            showCheckModal: false,
            showSuccessModal: true,
            actual_file: null,
            file_name: null,
          });
        }
        // window.location.reload();
      })
      .catch((err) => {
        this.setState({ disableAdd: false, hasError: true });
      });
  };

  handleChange = (file) => {
    this.setState({ actual_file: file, file_name: file.name });
  };

  ErrCancel = (e) => {
    e.preventDefault();
    this.setState({
      disableAdd: false,
      showAddModal: false,
      showCheckModal: false,
      showSuccessModal: false,
      hasError: false,
      actual_file: null,
      file_name: null,
    });
    this.props.parentCallback(true);
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-primary btn-sm float-right ml-2"
          title="Upload Special Transaction"
          onClick={this.handleshowAddModal}
        >
          <CloudUpload /> Upload Special Transaction
        </button>
        <Modal
          size="md"
          backdrop="static"
          show={this.state.showAddModal}
          onHide={() =>
            this.setState({ showAddModal: !this.state.showAddModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Upload Special Transaction</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div
                  className={
                    this.state.hasError
                      ? "alert alert-danger"
                      : "alert alert-danger d-none"
                  }
                  role="alert"
                >
                  Special Transaction Upload Failed
                </div>
              </div>
            </div>
            <form onSubmit={this.handleCheck} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Description</label>
                  <input
                    className="form-control"
                    type="text"
                    onChange={(e) => {
                      this.setState({
                        description: e.target.value,
                      });
                    }}
                    required
                  />
                </div>
                <div className="form-group col-md-12 col-sm-12">
                  <FileUploader
                    multiple={false}
                    handleChange={this.handleChange}
                    types={["XLSX"]}
                    classes="dropzone drop_area"
                  />
                  {this.state.actual_file ? (
                    <div
                      className="alert alert-success font-weight-bold"
                      role="alert"
                    >
                      Uploaded File name: {this.state.file_name}
                    </div>
                  ) : (
                    <div className="alert alert-danger" role="alert">
                      No File Uploaded
                    </div>
                  )}
                </div>
              </div>
              <div className="float-right">
                <button
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                  disabled={this.state.disableAdd}
                >
                  Proceed
                </button>
                <button
                  onClick={this.handleshowAddModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <Modal
          size="xl"
          show={this.state.showCheckModal}
          backdrop="static"
          onHide={() =>
            this.setState({ showCheckModal: !this.state.showCheckModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Upload Special Transaction: Checking</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="alert alert-info">
                  <strong>File:</strong> {this.state.file_name}
                  <br />
                  <strong>Total Records:</strong> {this.state.rec_no}
                  <br />
                  <strong>Total Errors:</strong> {this.state.err_no}
                  <br />
                </div>
              </div>
            </div>
            <div class="table-responsive mb-10">
              <table class="table table-xs table-bordered mb-0">
                <thead className="thead-secondary">
                  <tr className="text-center">
                    <th>#</th>
                    <th className="text-nowrap">Employee #</th>
                    <th className="text-nowrap">Employee Name</th>
                    <th className="text-nowrap">Earning/Deduction Code</th>
                    <th className="text-nowrap">
                      Earning/Deduction Description
                    </th>
                    <th className="text-nowrap">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.checkData.map((row) => (
                    <tr key={row.number}>
                      <td>{row.number}</td>
                      <td className={row.err_emp_no == 1 ? "bg-danger" : ""}>
                        {row.emp_no}
                      </td>
                      <td>{row.name}</td>
                      <td className={row.err_ed_code == 1 ? "bg-danger" : ""}>
                        {row.ed_code}
                      </td>
                      <td>{row.ed_name}</td>
                      <td
                        className={
                          row.err_amount == 1
                            ? "bg-danger text-right"
                            : "text-right"
                        }
                      >
                        {row.amount}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {this.state.err_no > 0 ? (
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="alert alert-danger">
                    {this.state.err_no} Invalid record(s) found, please correct
                    the data and re-upload
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </Modal.Body>
          <Modal.Footer>
            {this.state.err_no > 0 ? (
              <div className="float-right">
                <button
                  onClick={this.ErrCancel}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            ) : (
              <div className="float-right">
                <button
                  onClick={this.handleSubmit}
                  className="btn btn-primary btn-sm mr-2"
                  type="button"
                  disabled={this.state.disableAdd}
                >
                  Save
                </button>
                <button
                  onClick={this.handleshowCheckModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            )}
          </Modal.Footer>
        </Modal>
        <Modal
          size="lg"
          show={this.state.showSuccessModal}
          backdrop="static"
          onHide={() =>
            this.setState({ showSuccessModal: !this.state.showSuccessModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Upload Special Transaction: Successful</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <div className="alert alert-success">
                  <strong>Import Result</strong>
                  <br />
                  <strong>Total Records:</strong> {this.state.rec_no}
                  <br />
                  <strong>Total Errors:</strong> {this.state.err_no}
                  <br />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="float-right">
              <button
                onClick={() =>
                  this.setState({
                    showSuccessModal: !this.state.showSuccessModal,
                  })
                }
                className="btn btn-danger btn-sm"
                type="button"
              >
                Close
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
